import { useState } from "react";

type MatrixRow = {
  category: string;
  oe: string[];
  oem: string[];
  mic: string;
};

type MatrixData = {
  brand: string;
  icon: string;
  color: string;
  rows: MatrixRow[];
};

const matrixData: MatrixData[] = [
  {
    brand: "MERCEDES-BENZ",
    icon: "ri-steering-line",
    color: "#C9A84C",
    rows: [
      {
        category: "Фильтры ТО (Масло/Воздух/АКПП)",
        oe: ["A0001802609", "A1120940604", "A2761800009", "A2128300318", "A1668300218", "A2212770195"],
        oem: ["MANN: HU 718/5x", "MAHLE: LAK 878/S", "ZF/MEYLE"],
        mic: "Фильтровальная бумага высокой пылеемкости; Угольные фильтры двойного действия; Поддоны АКПП с заводскими магнитами.",
      },
      {
        category: "Тормоза и Зажигание (SBC/Колодки)",
        oe: ["A0044204320", "A2214211112", "A0041591803", "A0094361405"],
        oem: ["TEXTAR: 2333401", "BREMBO: 09.A732.11", "BOSCH"],
        mic: "Керамика без пыли и скрипа; Высокоуглеродистые диски от биения.",
      },
      {
        category: "OM642/OM651 Дизель",
        oe: ["A6421880580", "A6420907737", "A6421401460", "A6420901680", "A6512000600"],
        oem: ["ELRING", "PIERBURG", "BOSCH", "GARRETT"],
        mic: "Термостойкие уплотнения из фторкаучука; Усиленные алюминиевые вихревые заслонки; Турбины с кованым колесом.",
      },
      {
        category: "M271/M274 ГРМ и Охлаждение",
        oe: ["A2710501447", "A2710503347", "A2742000107", "A2742000800"],
        oem: ["INA", "FEBI", "PIERBURG"],
        mic: "Закаленные шестерни против износа; Высокопрочные цепи; Стойкие к климату пластиковые корпуса помп.",
      },
      {
        category: "M272/M273/M276/M278",
        oe: ["A2721402401", "A2760700601", "A2762000515", "A2780503300"],
        oem: ["PIERBURG", "BOSCH", "SIL", "INA"],
        mic: "Усиленные алюминиевые тяги впускного коллектора; Высокоточные ТНВД; Бесшумные помпы.",
      },
      {
        category: "W222/W212/W166 Подвеска и Пневмо",
        oe: ["A2223204713", "A1663200325", "A2223200604", "A2046201204"],
        oem: ["BILSTEIN", "AMK/WABCO", "LEMFÖRDER"],
        mic: "Утолщенные взрывозащищенные пневмобаллоны из натурального каучука; Усиленные антикоррозийные подрамники.",
      },
    ],
  },
  {
    brand: "BMW",
    icon: "ri-car-line",
    color: "#1B6EC2",
    rows: [
      {
        category: "ТО и Зажигание",
        oe: ["11427512300", "24118612901", "34116764021", "12138616153"],
        oem: ["MANN", "ZF", "ZIMMERMANN", "BOSCH/DELPHI"],
        mic: "Поддоны ZF с мощными магнитами; Формы 1:1 с высоким коэффициентом фильтрации.",
      },
      {
        category: "N47/N57/M57 Дизель",
        oe: ["11617811909", "11237800026", "12230035934", "13517808089"],
        oem: ["METZGER", "CORTECO", "BOSCH", "BERU"],
        mic: "Алюминиевые заслонки (исключают отрыв); Термостойкие шкивы коленвала из NBR.",
      },
      {
        category: "M54/N52/N54/N55 Охлаждение",
        oe: ["11517586925", "11517632426", "11537549476", "17117573781"],
        oem: ["PIERBURG", "MAHLE/BEHR", "HELLA"],
        mic: "Модернизированные платы управления помп; Утолщённые расширительные бачки; Сетки клапанов VANOS из нержавейки.",
      },
      {
        category: "N20/B48/N63 ГРМ и Уплотнения",
        oe: ["11318648988", "11318685091", "11428585235", "11340029751"],
        oem: ["INA", "ELRING", "PIERBURG", "BOSCH"],
        mic: "Усиленные композитные направляющие цепи; Алюминиевые корпуса масляных фильтров; Маслосъёмные колпачки из FKM.",
      },
      {
        category: "Подвеска и Рулевое",
        oe: ["31126771893", "33506866742", "32106777483", "32106884025"],
        oem: ["TRW/LEMFÖRDER", "SACHS", "DUNLOP", "ZF LENKSYSTEME"],
        mic: "Усиленные сайлентблоки для российских дорог; Новые рулевые рейки EPS с поддержкой заводского кодирования.",
      },
    ],
  },
  {
    brand: "VAG GROUP (Audi/VW/Porsche)",
    icon: "ri-car-washing-line",
    color: "#C0392B",
    rows: [
      {
        category: "ТО и Трансмиссия",
        oe: ["06J115403Q", "0B5325330A", "7L6615301D", "101905631H"],
        oem: ["MANN", "VAICO", "BREMBO/TEXTAR", "NGK"],
        mic: "Обратные клапаны точного давления; Чугунные диски стойкие к термоусадке.",
      },
      {
        category: "EA888/EA113 ГРМ и Течи",
        oe: ["06K121011C", "06H103495AE", "06K109158AD", "06D109309C"],
        oem: ["HEPU/GRAF", "BORGWARNER", "INA"],
        mic: "Полностью алюминиевые корпуса помп (без трещин); Диафрагмы КВКГ из фторполимера; Сверхтвёрдые толкатели с DLC-покрытием.",
      },
      {
        category: "EA839/EA837/EA897 V6/TDI",
        oe: ["06M121013", "06E121012A", "059130755BB", "059109469E"],
        oem: ["PIERBURG", "BOSCH", "INA"],
        mic: "Усиленные сальники и подшипники водяных помп; Алюминиевые тройники системы охлаждения (полная герметичность).",
      },
      {
        category: "Пневмо/DSG/Подвеска",
        oe: ["7L6616039D", "7L0521102N", "0AM325025D", "8K0407505A"],
        oem: ["BILSTEIN", "BORGWARNER", "MEYLE", "LEMFÖRDER"],
        mic: "Оригинальная посадка для экстремальных холодов; Усиленные подвесные подшипники кардана; Утолщённые гидроаккумуляторы мехатроника DSG.",
      },
    ],
  },
  {
    brand: "JAGUAR LAND ROVER",
    icon: "ri-steering-2-line",
    color: "#27AE60",
    rows: [
      {
        category: "ТО и Тормоза (Haldex)",
        oe: ["LR011279", "LR073669", "LR011593", "LR032298"],
        oem: ["MANN", "TEXTAR", "BORGWARNER", "NGK"],
        mic: "Высокоплотный фильтрующий материал (исключает пробой масла); Керамика для мощного торможения.",
      },
      {
        category: "3.0T V6 SC / 5.0 V8 (Бензин)",
        oe: ["LR090630", "LR092992", "LR097328", "LR032048"],
        oem: ["HELLA", "INA/FEBI", "PIERBURG"],
        mic: "Алюминиевые патрубки охлаждения (замена заводского пластика); Стабильные высокопроизводительные электронные помпы.",
      },
      {
        category: "3.0 TDV6 / 2.0T (Дизель/Бензин)",
        oe: ["LR013487", "LR073585", "LR025620", "LR006861"],
        oem: ["FORD/OEM", "BOSCH", "BORGWARNER", "VALEO"],
        mic: "Усиленные роторы масляных насосов (решают проблему клина коленвала); Утолщённые чугунные выпускные коллекторы.",
      },
      {
        category: "Пневмоподвеска и Трансмиссия",
        oe: ["LR044360", "LR015303", "LR051411", "LR034262"],
        oem: ["AMK/HITACHI", "BILSTEIN", "ZF/BOSCH"],
        mic: "Долговечные моторы компрессоров пневмоподвески; Утолщённые пневмобаллоны; Усиленные графитовые щётки моторов дифференциала.",
      },
    ],
  },
];

export default function MatrixSection() {
  const [activeTab, setActiveTab] = useState(0);

  const active = matrixData[activeTab];

  return (
    <section id="matrix" className="bg-[#060A10] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Матрица ТО и ремонта</span>
          </div>
          <h2 className="text-white mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4.5vw, 60px)", letterSpacing: "0.03em" }}>
            ПОЛНЫЕ OE-АРТИКУЛЫ: MERCEDES · BMW · VAG · JLR
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mb-8">
            Все артикулы OE (Europe) верифицированы. Белая таможня, ГТД/НДС, Честный ЗНАК на каждую позицию. Данные доступны для парсинга и интеграции в ваши ERP-системы.
          </p>

          {/* ── СТРАТЕГИЧЕСКАЯ ЧЕСТНОСТЬ — Highlight Card ── */}
          <div className="relative bg-gradient-to-r from-[#C9A84C]/12 via-[#0D1420] to-[#0D1420] border border-[#C9A84C]/50 rounded-sm p-7 mb-2 overflow-hidden">
            {/* Accent bar */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C]"></div>
            <div className="pl-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-[#C9A84C]/15 border border-[#C9A84C]/40 rounded-sm flex-shrink-0">
                  <i className="ri-shield-star-line text-[#C9A84C] text-lg"></i>
                </div>
                <span className="text-[#C9A84C] text-[11px] font-black tracking-[0.35em] uppercase">Стратегическая честность · Дизельные OEM-каналы</span>
              </div>
              <blockquote className="text-white text-sm leading-relaxed font-medium">
                СТРАТЕГИЧЕСКАЯ ЧЕСТНОСТЬ: Учитывая дефицит дизельных легковых автомобилей на внутреннем рынке КНР, запасы OE-деталей объективно ограничены. Чтобы закрыть этот пробел, мы напрямую внедряем каналы ведущих OEM-производителей (<strong className="text-[#C9A84C]">Bosch, Pierburg</strong> и др.), предоставляя вам <strong className="text-[#C9A84C]">100% качество сборочного конвейера</strong>.
              </blockquote>
            </div>
          </div>
        </div>

        {/* Brand Tabs */}
        <div className="flex flex-wrap gap-2 mb-8">
          {matrixData.map((m, idx) => (
            <button
              key={m.brand}
              onClick={() => setActiveTab(idx)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-sm text-xs sm:text-sm font-semibold tracking-wide uppercase transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === idx
                  ? "bg-[#C9A84C] text-[#0A0F1A]"
                  : "bg-[#0D1420] border border-[#1E2A3A] text-gray-400 hover:border-[#C9A84C]/40 hover:text-white"
              }`}
            >
              <i className={`${m.icon} text-base`}></i>
              <span className="hidden sm:inline">{m.brand}</span>
              <span className="sm:hidden">{m.brand.split(" ")[0]}</span>
            </button>
          ))}
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-sm border border-[#1E2A3A] -mx-4 sm:mx-0 px-4 sm:px-0">
          <table className="w-full text-sm min-w-[600px]">
            <thead>
              <tr className="bg-[#0D1420] border-b border-[#1E2A3A]">
                <th className="text-left text-[#C9A84C] font-semibold tracking-wide uppercase px-6 py-4 text-xs whitespace-nowrap">Категория</th>
                <th className="text-left text-[#C9A84C] font-semibold tracking-wide uppercase px-6 py-4 text-xs whitespace-nowrap">Артикулы OE (Europe)</th>
                <th className="text-left text-[#C9A84C] font-semibold tracking-wide uppercase px-6 py-4 text-xs whitespace-nowrap">Премиум OEM (IAM)</th>
                <th className="text-left text-[#C9A84C] font-semibold tracking-wide uppercase px-6 py-4 text-xs">Made in China — Преимущества</th>
              </tr>
            </thead>
            <tbody>
              {active.rows.map((row, idx) => (
                <tr
                  key={row.category}
                  className={`border-b border-[#1E2A3A] hover:bg-[#0D1420]/60 transition-colors ${
                    idx % 2 === 0 ? "bg-[#080C14]" : "bg-[#060A10]"
                  }`}
                >
                  <td className="px-6 py-5 align-top">
                    <span className="text-white font-semibold text-sm">{row.category}</span>
                  </td>
                  <td className="px-6 py-5 align-top">
                    <div className="flex flex-col gap-1">
                      {row.oe.map((code) => (
                        <code key={code} className="text-[#C9A84C] text-xs font-mono bg-[#C9A84C]/10 px-2 py-0.5 rounded-sm w-fit">
                          {code}
                        </code>
                      ))}
                    </div>
                  </td>
                  <td className="px-6 py-5 align-top">
                    <div className="flex flex-wrap gap-1">
                      {row.oem.map((brand) => (
                        <span key={brand} className="text-gray-300 text-xs bg-[#1E2A3A] px-2 py-0.5 rounded-sm whitespace-nowrap">
                          {brand}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="px-6 py-5 align-top">
                    <p className="text-gray-400 text-xs leading-relaxed">{row.mic}</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* CTA below table */}
        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-[#0D1420] border border-[#C9A84C]/20 p-6 rounded-sm">
          <div>
            <div className="text-white font-semibold mb-1">Нужна полная матрица с ценами?</div>
            <div className="text-gray-400 text-sm">Запросите B2B прайс-лист с актуальными ценами на все позиции. Белая таможня, ГТД/НДС, Честный ЗНАК.</div>
          </div>
          <a
            href="#contact"
            className="flex items-center gap-2 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-6 py-3 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line"></i>
            Запросить B2B прайс-лист
          </a>
        </div>
      </div>
    </section>
  );
}
